import type { EditableFeatureFlags, PlatformSettings } from '@/types/settings.types';

import { apiClient } from './api.service';

/**
 * What the server actually accepts. `coinRules` is returned by GET but rejected as a write —
 * it is repriced from code on every coin-rules version bump, so an admin edit would be silently
 * discarded. The write shape leaves it out rather than sending something that gets ignored.
 */
export interface UpdateSettingsBody {
  fees: PlatformSettings['fees'];
  payment: PlatformSettings['payment'];
  featureFlags: EditableFeatureFlags;
}

export const settingsApi = {
  get: (): Promise<PlatformSettings> =>
    apiClient.get<PlatformSettings>('/admin/settings').then((r) => r.data),

  update: (body: UpdateSettingsBody): Promise<PlatformSettings> =>
    apiClient.patch<PlatformSettings>('/admin/settings', body).then((r) => r.data),
};
